import { action } from 'typesafe-actions'
import { UserCourseActionTypes } from './types'
import { IUserCourse } from '../interface'

// Search Request
export const listRequest = (searchParams:any) => action(UserCourseActionTypes.LIST_REQUEST, searchParams)
export const listSuccess = (data: IUserCourse[]) => action(UserCourseActionTypes.LIST_SUCCESS, data)
export const listError = (errors: any) => action(UserCourseActionTypes.LIST_ERROR, errors)
export const listClear = () => action(UserCourseActionTypes.LIST_CLEAR)

// Select Data
export const selectData = (id: string) => action(UserCourseActionTypes.SELECT, id)
export const selectedData = () => action(UserCourseActionTypes.SELECTED)
export const selectedClear = () => action(UserCourseActionTypes.CLEAR_SELECTED)

// Create
export const createRequest = (doc: IUserCourse) => action(UserCourseActionTypes.CREATE_REQUEST, doc)
export const createSuccess = (doc: IUserCourse) => action(UserCourseActionTypes.CREATE_SUCCESS, doc) // Newly created data
export const createError = (errors: any) => action(UserCourseActionTypes.CREATE_ERROR, errors)

// Read
export const readRequest = (data: IUserCourse) => action(UserCourseActionTypes.READ_REQUEST, data)
export const readSuccess = (data: IUserCourse) => action(UserCourseActionTypes.READ_SUCCESS, data)
export const readError = (errors: any) => action(UserCourseActionTypes.READ_ERROR, errors)

// Update
export const updateRequest = (keyValues: any) => action(UserCourseActionTypes.UPDATE_REQUEST, keyValues)
export const updateSuccess = (doc: IUserCourse) => action(UserCourseActionTypes.UPDATE_SUCCESS, doc) // Updated Data
export const updateError = (errors: any) => action(UserCourseActionTypes.UPDATE_ERROR, errors)

// Delete
export const deleteRequest = (doc: IUserCourse) => action(UserCourseActionTypes.DELETE_REQUEST, doc)
export const deleteSuccess = (id: string) => action(UserCourseActionTypes.DELETE_SUCCESS, id)  // Return deleted User id to remove from state
export const deleteError = (errors: any) => action(UserCourseActionTypes.DELETE_ERROR, errors)

// Search Request
export const downloadRequest = (searchParams:any) => action(UserCourseActionTypes.DOWNLOAD_REQUEST, searchParams)
export const downloadSuccess = (url: string) => action(UserCourseActionTypes.DOWNLOAD_SUCCESS, url)
export const downloadError = (errors: any) => action(UserCourseActionTypes.DOWNLOAD_ERROR, errors)